export default __webpack_public_path__ + "static/media/mobile.2cb57f80.jpg";